export default {
  components: {
    buttons: {
      createMaterial: 'Create New Material',
      advancedSearch: 'Advanced Search',
    },
    tableRequestedMaterials: {
      id: 'Id',
      creationDate: 'Creation Date',
      name: 'Material Name',
      userCreate: 'Creation User',
      area: 'Area',
      phase: 'Current Status',
      updateDate: 'Last Update',
      code: 'ERP Code',
      statusPhase: 'Status Condition',
      integrationStatus: 'Integration Status',
    },
    status: {
      white: 'Draft',
      gray: 'Material Request Canceled',
      yellow: 'Request in process',
      green: 'Request Completed',
      red: 'Request Rejected',
      statusTitle: 'Current Status',
    },
    integrationStatus: {
      white: 'Draft',
      yellow_integration_status: 'Pending Integration',
      orange: 'Processed',
      green: 'Received ok',
      blue: 'Integrated',
      red: 'Error in ERP',
    },
    advanceSearch: "Search...",
    editMatReq: "Editar solicitud",
    orgDiv: "Organization Division",
    all: "(All)",
    creationDialog: {
      title: "Create New Material Request",
      confirmButton: "Create",
      cancelButton: "Cancel",
      parentArea: "Parent Area",
      area: "Area",
      selectParentArea: "Select a parent area",
      selectArea: "Select an area/center",
    },
    rangeDates: {
      selectADay: "Select a day",
      from: "Start Date",
      to: "End Date",
      report: "Report",
      reporteGenericoWorkflow: "Creation of Material Requests report",
      reporteExportarCollahuasi: "Export",
      reportAnalyst: "Analyst Report",
      reporteCollahuasiEtapaAnalista: "Analyst stage request report",
      reportRejectOrAcceptDesc: "Report Accepted or Rejected",
      reporteCollahuasiRechazoAprobacion: "Report of approved or rejected material requests",
      generateButton: "Generate Report",
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/cataloger/requestedMaterials/components.js